import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export enum THEME_ID {
  AS_DEVICE = 'AS_DEVICE',
  DARK = 'DARK',
  LIGHT = 'LIGHT',
}

type AppState = {
  language: string
  themeId: THEME_ID
}

const THEME_STORAGE_KEY = 'musictmm_theme_id'

function readThemeFromStorage(): THEME_ID {
  if (typeof window === 'undefined') return THEME_ID.DARK
  const raw = localStorage.getItem(THEME_STORAGE_KEY)
  if (raw === THEME_ID.AS_DEVICE || raw === THEME_ID.DARK || raw === THEME_ID.LIGHT) {
    return raw
  }
  return THEME_ID.DARK
}

export const initialState: AppState = {
  language: 'en',
  themeId: readThemeFromStorage(),
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload
    },

    setUserSelectedTheme: (state, action: PayloadAction<THEME_ID>) => {
      state.themeId = action.payload
      if (typeof window !== 'undefined') {
        localStorage.setItem(THEME_STORAGE_KEY, action.payload)
      }
    },
  },
})

export const { setLanguage, setUserSelectedTheme } = appSlice.actions
export default appSlice.reducer
